import React, { Component } from 'react';
import VideoPlayer from "../Common/VideoPlayer";
import About from "../Common/About";
import Slider from 'react-slick';

class Splash extends Component {
    /**
     * Render splash page
     * @returns {*}
     */
    constructor() {
        super();
        this.state = {
            fadeValue: 1,
            seconds: 0,
            videoDisplay: 'block'
        }
        this.next = this.next.bind(this);
        this.pauseVideo = this.pauseVideo.bind(this);
    }

    videoDisplayHandle = () => {
        this.state = {
            videoDisplay: 'none'
        }
    }

    gotoWebApp = (e) => {
        e.preventDefault();
        this.setState({
            videoDisplay: 'none'
        })
    }

    pauseVideo() {
        // this.refs.video.pause();
    }

    next() {
        this.pauseVideo();
        this.slider.slickNext();
    }

    render() {
        const TopSliderSettings = {
            arrows: true,
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
            autoplay: false,
            autoplaySpeed: 6000,
            fadeOut: 1,
            beforeChange: (current, nextSlide) => {
                if (nextSlide == 2 || nextSlide == 0) {
                    this.next()
                }
            },
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                    }
                },
            ]
        };

        const origin = window.location.origin;
        const poster = "/assets/images/eathdeck/splash-poster.png";
        const video = `${origin}/assets/videos/061441053-ocean-scenery-rubbish-and-poll_H264_420.mp4`;
        const introPoster = "/assets/images/eathdeck/app-intro-earthDECKS_poster.png";
        const introVideo = `${origin}/assets/videos/app-intro-earthDECKS.mp4`;
        if (this.state.seconds >= 8) {
            this.videoDisplayHandle();
            this.props.homeAppIcon();
            this.slider.slickPlay();
        } else if (this.state.videoDisplay != 'none' && this.state.seconds == 0) {
            setTimeout(() => {
                if (this.slider)
                    this.slider.slickPause();
            }, 2000)
        }

        return (
            <div>
                <section className="film-page splash-video" style={{ opacity: this.state.fadeValue, display: this.state.videoDisplay }}>
                    <VideoPlayer
                        poster={poster}
                        source={video}
                        play={false}
                        onlyPlayer={true}
                        skipTo="home"
                        fullScreen={true}
                        autoPlay={true}
                        muted={true}
                        gotoWebApp={this.gotoWebApp}
                        onFadeOutVideo={(ratioValue, seconds) => {
                            this.setState({
                                fadeValue: ratioValue,
                                seconds
                            })
                        }}
                    />
                    <div className="row app-icons">

                        <div className="medium-4 columns ">
                            <a href="#">
                                <img src="/assets/images/eathdeck/AppleStore-ios-icon.png" alt="" />
                            </a>

                            <a href="#">
                                <img src="/assets/images/eathdeck/GooglePlay-android-icon.png" alt="" />
                            </a>
                        </div>
                        <div className="medium-4 columns text-center">
                            <a href="/home"
                                style={{ 'max-width': "230px" }}
                                onClick={this.gotoWebApp}
                                className="btn-primary splash-btn secondary-gradient-bg">
                                Go to <br /> Web App
                            </a>
                        </div>
                        <div className="medium-4 columns text-right">
                            <a href="http://earthdecks.net/petri/" style={{ 'max-width': "230px" }} target="_blank" className="btn-primary splash-btn primary-gradient-bg">More on <br /> PETRI</a>
                        </div>
                    </div>
                </section>
                <Slider {...TopSliderSettings} ref={c => (this.slider = c)} className="slick-slider">
                    <div>
                        <div className="film-slider" style={{ backgroundImage: 'url(/assets/images/eathdeck/film_01.png)' }} onClick={this.next} >
                            <div className="banner-container">
                                <div className="bottle-banner">
                                    <h2>Try our new media experience and <br />get your customized earthDECK!</h2><br />
                                    <img src="../../assets/images/eathdeck/word-cloud-banner.svg" style={{ width: "500px", height: "auto", paddingTop: "100px", margin: "auto" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>

                        <div className="film-slider " style={{ backgroundImage: 'url(assets/images/eathdeck/film_01.png)', textAlign: 'center', 'display': 'flex', 'alignItems': 'center', 'paddingTop': '0.5%' }} >
                            <div className="banner-container">
                                <VideoPlayer
                                    poster={introPoster}
                                    source={introVideo}
                                    play={false}
                                    onlyPlayer={true}
                                    autoPlay={false}
                                    muted={false}
                                    height="75%"
                                    width="75%"
                                    hideProgress={false}
                                    hideSkipArrow={true}
                                    showControls={true}
                                    videoStyle={{ width: '75%', marginLeft: '12.5%' }}
                                />
                            </div>
                        </div>
                    </div>
                    {/*<div>
                        <div className="film-slider" style={{ backgroundImage: 'url(assets/images/eathdeck/film_01.png)' }} onClick={this.next}>
                            <div className="banner-container">
                                <h2 className="banner-title">
                                    Your earthDECK
                                </h2>
                                <h4 className="banner-subtitle">
                                    As the film plays, click on the screen when you see a topic that interests you.
                                </h4>
                                <div className="banner-globe">
                                    <img src="assets/images/eathdeck/globe-line.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="film-slider" style={{ backgroundImage: 'url(assets/images/eathdeck/film_01.png)' }} onClick={this.next}>
                            <div className="banner-container">
                                <h4 className="banner-subtitle m-t100">
                                    The film will not pause, but the globe will flash to show that your click was recorded
                                </h4>
                                <div className="banner-globe">
                                    <img src="assets/images/eathdeck/globe-neon.png" />
                                </div>
                            </div>
                        </div>
                    </div>*/}
                    <div>
                        <div className="film-slider" style={{ backgroundImage: 'url(assets/images/eathdeck/film_03.png)' }} >
                            <div className="banner-container">
                                <h4 className="banner-subtitle m-t100">
                                    In this new media experience, your clicks during the film generate your earthDECK.
                                </h4>
                                <div className="banner-btn">
                                    <ul style={{ "padding-inline-start": '0px' }}>
                                        {/*<li><a href="/login">LOGIN</a></li>
                                            <li><a href="/signup">SIGNUP</a></li>*/}
                                        <li><a href="/play-film">PLAY</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Slider>



                {/* <div className="row app-icons">
                        
                        <div className="medium-4 columns ">
                            <a href="#">
                                <img src="/assets/images/eathdeck/AppleStore-ios-icon.png" alt=""/>
                            </a>

                            <a href="#">
                                <img src="/assets/images/eathdeck/GooglePlay-android-icon.png" alt=""/>
                            </a>
                        </div>
                        <div className="medium-4 columns text-center">
                            <a href="/home" style={{'max-width': "230px"}} className="btn-primary splash-btn secondary-gradient-bg">Go to <br /> Web App</a>
                        </div>
                        <div className="medium-4 columns text-right">
                            <a href="http://earthdecks.net/petri/" style={{'max-width': "230px"}} target="_blank" className="btn-primary splash-btn primary-gradient-bg">More on <br /> PETRI</a>
                        </div>
                    </div> */}

                {/* <About /> */}
            </div>
        );
    }
}

//Connect action to component
export default Splash;


// WEBPACK FOOTER //
// ./components/Home/Splash.js